import React, { useEffect } from 'react';
import GlobalWrapper from '../../components/Wrapper/GlobalWrapper';
import { Alert, Box, Button, Icon, Paper } from '@mui/material';
import { useDispatch } from 'react-redux';
import { getGrievanceTicketToken } from '../../redux/features/generalSlice';
import { useSelector } from 'react-redux';
import Loader3D from '../../components/Loader/Loader3D';
const grievanceUrl = `${process.env.REACT_APP_GRIEVANCE_URL}grievance`;

export default function NavGrievanceTickets({ isAdmin }) {
  const dispatch = useDispatch();
  const grievanceToken = useSelector((state) => state.general.grievanceTicketToken.data);
  const grievanceTokenLoading = useSelector((state) => state.general.grievanceTicketToken.loading);

  const getGrievanceTokenForNav = () => {
    const params = {
      module: 'grievance',
      role: isAdmin ? 'admin' : 'user',
      expiresIn: '1m',
    };
    dispatch(getGrievanceTicketToken(params));
  };
  const gotoGrievance = () => {
    if (grievanceToken && !grievanceTokenLoading) {
      window.open(`${grievanceUrl}?token=${grievanceToken}`);
    }
  };

  useEffect(() => {
    getGrievanceTokenForNav();
  }, [isAdmin]);

  useEffect(() => {
    gotoGrievance();
  }, [grievanceToken, grievanceTokenLoading]);

  return (
    <GlobalWrapper title={isAdmin ? 'Admin Grievance' : 'Grievance Tickets'}>
      {grievanceTokenLoading && <Loader3D />}
      {grievanceToken && !grievanceTokenLoading && (
        <Paper elevation={6} sx={{ p: 3 }}>
          <Button
            endIcon={<Icon icon="ix:goto" width="25" height="25" style={{ color: '#41e20f' }} />}
            sx={{ boxShadow: 'none', px: 2 }}
            variant="outlined"
            color="success"
            onClick={gotoGrievance}
          >
            Go To
          </Button>
        </Paper>
      )}
      {!grievanceToken && !grievanceTokenLoading && (
        <Paper elevation={6} sx={{ p: 1, textAlign: 'center' }}>
          <Box sx={{ textAlign: 'center', fontSize: 20 }}>
            <Alert severity="error">Something went wrong, please try again later.</Alert>
          </Box>
          <Button
            variant="outlined"
            color="error"
            onClick={getGrievanceTokenForNav}
            sx={{
              my: 2,
              px: 4,
              borderRadius: '30px',
              fontWeight: 600,
              textTransform: 'none',
              boxShadow: 'none',
            }}
          >
            Retry
          </Button>
        </Paper>
      )}
    </GlobalWrapper>
  );
}
